<template>
  <div class="main-div openorders">
    <v-container fluid grid-list-md :style="{ maxWidth: '1240px' }">
      <v-layout row wrap>
        <v-flex xs12 md12 lg12>
          <v-card height="100%" class="main-card">
            <v-toolbar class="toolbar-chart" row wrap>
              <v-layout row wrap class="toolbar-layout">
                <v-flex xs12 sm4>
                  <v-select
                    class="markets-select"
                    :items="activeMarkets"
                    :menu-props="{ contentClass: 'openorders-dropdown' }"
                    placeholder="Choose market"
                    @change="loadOpenOrders"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4 class="text-xs-center toolbar-chart-title-row">
                  <v-toolbar-title class="toolbar-title">
                    Chart
                  </v-toolbar-title>
                </v-flex>
              </v-layout>
            </v-toolbar>
            <v-card-text>
              <StockChart
                v-if="selectedMarket"
                :market="selectedMarket"
                :sell-orders="sellOrderLevels"
                :buy-orders="buyOrderLevels"
                :closed-sell-orders="closedSellOrders"
                :closed-buy-orders="closedBuyOrders"
              />
              <div v-else class="text-xs-center chart-message">
                Please select a market first...
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row class="wrap mt-28">
        <v-flex xs12 md12 lg7 class="sell-order">
          <v-card class="main-card" height="100%">
            <v-toolbar class="toolbar">
              <v-toolbar-title class="toolbar-title">
                Open sell orders
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text style="padding: 0px !important;">
              <v-data-table
                :headers="openOrderHeaders"
                :items="openOrders || []"
                item-key="uuid"
                no-data-text="To view the current opened orders, you have to select a market."
              >
                <template slot="items" slot-scope="props">
                  <tr
                    v-if="!isMobile"
                    :style="{ cursor: 'pointer' }"
                    @click="e => (props.expanded = !props.expanded)"
                  >
                    <td>
                      {{
                        props.item.ts_opened_utc
                          | formatDate("DD MMM YYYY HH:mm")
                      }}
                    </td>
                    <td>
                      {{ props.item.price.toFixed(8) }}
                    </td>
                    <td>{{ props.item.quantity.toFixed(8) }}</td>
                    <td>{{ props.item.uuid }}</td>
                  </tr>
                  <tr
                    v-else
                    :style="{ cursor: 'pointer' }"
                    @click="e => (props.expanded = !props.expanded)"
                  >
                    <td class="pb-3 pt-2" colspan="2">
                      <v-layout row wrap>
                        <v-flex md12 xs12>
                          <v-layout row wrap>
                            <v-flex xs6 lg6 md6>
                              Opened (EET)
                            </v-flex>
                            <v-flex xs6 lg6 md6>
                              {{
                                props.item.ts_opened_utc
                                    | formatDate("DD MMM YYYY HH:mm")
                              }}
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs6 lg6 md6>
                              Price
                            </v-flex>
                            <v-flex xs6 lg6 md6>
                              {{ props.item.price.toFixed(8) }}
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs6 lg6 md6>
                              Quantity
                            </v-flex>
                            <v-flex xs6 lg6 md6>
                              {{ props.item.quantity.toFixed(8) }}
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs6 lg6 md6>
                              Order ID
                            </v-flex>
                            <v-flex xs6 lg6 md6>
                              {{ props.item.uuid }}
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </td>
                  </tr>
                </template>
                <template slot="expand" slot-scope="props">
                  <TradeDetails
                    :sell-order="props.item"
                    :base-currency="props.item.base_currency"
                  />
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md12 lg5 class="overall-statistics">
          <v-card class="main-card">
            <v-toolbar class="toolbar">
              <v-toolbar-title class="toolbar-title">
                Overall statistics
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="statistic-area">
              <v-layout row wrap class="statistic-row-first">
                <v-flex md8 xs7 class="statistic-title"
                  >Total open sell orders</v-flex
                >
                <v-flex md4 xs5 class="text-xs-right statistic-row-one">
                  <span class="statistic-value">{{
                    stats.totalOpenSellOrders
                  }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="statistic-row-second">
                <v-flex md8 xs7 class="statistic-title"
                  >Number of individual acquisitions <br />
                  in open sell orders
                </v-flex>
                <v-flex md4 xs5 class="text-xs-right value-numbers statistic-row-two">
                  <span class="statistic-value">{{
                    stats.totalOpenBuyOrders
                  }}</span>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-dialog
          v-model="addManualBuyOrderDialogOpened"
          lazy
          max-width="706px"
        >
          <AddManualBuyOrderAccumulatedFunds
            @close-dialog="closeDialogForManualBuy"
            @closeFundModal="addManualBuyOrderDialogOpened = false"
          ></AddManualBuyOrderAccumulatedFunds>
        </v-dialog>
      </v-layout>
      <v-layout class="mt-64">
        <v-flex>
          <MarketActions
            @clicked="onClickInfoPopUp"
            @addHistoryBtnClick="clickInfoPopUp"
          >
          </MarketActions>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style scoped>
>>> th,
>>> td {
  padding-left: 0px !important;
}
.mt-28 {
  margin-top: 28px !important;
}
.mt-32 {
  margin-top: 32px !important;
}
.mt-64 {
  margin-top: 64px !important;
}
.pl-10 {
  padding-left: 10px !important;
}
.pr-10 {
  padding-right: 10px !important;
}
>>> .markets-select .v-input__slot::before {
  border-style: none !important;
}
.value-numbers {
  padding-top: 12px !important;
}
.sell-order {
  padding-right: 10px !important;
}
.overall-statistics {
  padding-left: 10px !important;
}
>>> .theme--light .v-list__tile__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
>>> .theme--light .v-list__tile {
  padding-left: 24px !important;
}

>>> .theme--light.v-input input::placeholder,
>>> .theme--light.v-input textarea::placeholder {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #7395d0;
}
.theme--light.application .main-div {
  background-color: #f2f7ff !important;
}
>>> .theme--light
  .markets-select
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
>>> .theme--light .markets-select .v-select__slot {
  border: 1px solid #7395d0;
  box-sizing: border-box;
  border-radius: 30px;
  padding-left: 8px;
  padding-right: 8px;
  height: 40px;
}
>>> .theme--light .markets-select .v-select__slot .v-select__selections {
  padding-left: 16px;
}
.theme--light .chart-message {
  padding-top: 50px;
  padding-bottom: 24px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
.theme--light .statistic-row-first {
  padding: 22px 8px 24px;
}
.theme--light .statistic-row-second {
  padding: 0 8px;
  margin-bottom: 8px !important;
}
.theme--light .statistic-value {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #103a84;
  border: 1px solid #d1e2ff;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 9px 26px;
}
.theme--light .statistic-area {
  border: 1px solid #e6efff;
  box-sizing: border-box;
  border-radius: 10px;
  margin-top: 4px;
}
.theme--light .statistic-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}
.theme--light .toolbar-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #103a84;
}
.theme--light .toolbar {
  background: #e6efff;
  border-radius: 10px;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.theme--light .toolbar-chart .toolbar-chart-title-row {
  padding-top: 28px;
}
.theme--light .toolbar-chart .markets-select {
  padding-top: 20px;
}
.theme--light .toolbar-chart {
  background: #e6efff;
  border-radius: 10px;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.theme--light .main-card {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 15px;
  padding: 32px;
}
>>> .theme--light.v-table thead tr:first-child {
  border-bottom: 1px solid #e6efff;
}
>>> .theme--light.v-table tbody tr:not(:first-child) {
  border-top: 1px solid #e6efff;
}

>>> .theme--light.v-datatable .v-datatable__actions {
  border-top: 1px solid #e6efff;
}

>>> .theme--light.v-datatable .v-datatable__expand-col--expanded {
  border-bottom: 1px solid #e6efff;
}
>>> .theme--light.v-datatable thead th {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7395d0;
}
>>> .theme--light.v-datatable tbody tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}

>>> .theme--light.v-datatable tbody tr td .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}
>>> .theme--light.v-datatable thead th.column.sortable.active,
>>> .theme--light.v-datatable thead th.column.sortable.active .v-icon,
>>> .theme--light.v-datatable thead th.column.sortable:hover {
  color: #103a84;
}
>>> .theme--light .v-datatable__actions {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: #7395d0;
}
>>> .theme--light .v-datatable__actions .v-select__selections {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84 !important;
  max-height: 24px;
}

>>> .theme--light
  .v-datatable__actions
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84;
  padding-left: 8px;
}

>>> .theme--light .v-datatable__actions .v-input__slot {
  border: 0.8px solid #103a84;
  box-sizing: border-box;
  border-radius: 5px;
  max-height: 24px;
}

>>> .v-datatable__actions
  .v-text-field
  > .v-input__control
  > .v-input__slot::after,
>>> .v-datatable__actions
  .v-text-field
  > .v-input__control
  > .v-input__slot::before {
  width: 0px;
}
>>> .theme--light .v-datatable__actions .v-btn {
  color: #103a84;
}
>>> .theme--light.v-btn.v-btn--disabled,
>>> .theme--light.v-btn.v-btn--disabled .v-btn__loading,
>>> .theme--light.v-btn.v-btn--disabled .v-icon {
  color: #b8d2ff !important;
}

>>> .v-datatable__actions .theme--light.v-icon {
  color: #103a84 !important;
}

>>> .v-datatable__actions .v-input__append-inner {
  margin-top: 0px !important;
}

/**********************************/

>>> .theme--dark
  .v-list__tile.v-list__tile--active.primary--text
  .v-list__tile__title {
  color: #ffffff;
}
>>> .theme--dark .v-list__tile__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
}
>>> .theme--dark.v-list {
  background: #303030;
}
>>> .theme--dark .v-list__tile {
  padding-left: 24px !important;
}
>>> .theme--dark.v-table {
  background: #212121;
}
>>> .theme--dark.v-datatable .v-datatable__actions {
  background: #212121;
}
>>> .theme--dark.v-datatable thead th {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark.v-datatable tbody tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #e9e9e9;
}
>>> .theme--dark.v-datatable tbody tr td .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
}
>>> .theme--dark.v-datatable thead th.column.sortable.active,
>>> .theme--dark.v-datatable thead th.column.sortable.active .v-icon,
>>> .theme--dark.v-datatable thead th.column.sortable:hover {
  color: #ffffff;
}
>>> .theme--dark .v-datatable__actions {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark .v-datatable__actions .v-select__selections {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  max-height: 24px;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark .markets-select .v-select__slot .v-select__selections {
  padding-left: 16px;
}
>>> .theme--dark.v-input input::placeholder,
>>> .theme--dark.v-input textarea::placeholder {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #e9e9e9;
}
>>> .theme--dark
  .v-datatable__actions
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-left: 16px;
  color: #ffffff;
}

>>> .theme--dark .v-datatable__actions .v-input__slot {
  border: 0.8px solid #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
  max-height: 24px;
}
>>> .v-datatable__actions .theme--dark.v-icon {
  color: #ffffff !important;
}
>>> .theme--dark.v-btn.v-btn--disabled,
>>> .theme--dark.v-btn.v-btn--disabled .v-btn__loading,
>>> .theme--dark.v-btn.v-btn--disabled .v-icon {
  color: rgba(235, 235, 245, 0.6) !important;
}

>>> .theme--dark
  .markets-select
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark .markets-select .v-select__slot {
  border: 1px solid rgba(235, 235, 245, 0.6);
  box-sizing: border-box;
  border-radius: 30px;
  padding-left: 8px;
  padding-right: 8px;
  height: 40px;
}
.theme--dark .chart-message {
  padding-top: 50px;
  padding-bottom: 24px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #e9e9e9;
}
.theme--dark .statistic-row-first {
  padding: 18px 8px 14px;
}
.theme--dark .statistic-row-second {
  padding: 18px 8px 14px;
}
.theme--dark .statistic-value {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #e9e9e9;
  border: 1px solid rgba(235, 235, 245, 0.3);
  box-sizing: border-box;
  border-radius: 10px;
  padding: 9px 26px;
}
.theme--dark .statistic-area {
  border: 1px solid #303030;
  box-sizing: border-box;
  border-radius: 10px;
  margin-top: 4px;
}
.theme--dark .statistic-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #e9e9e9;
}
.theme--dark .toolbar-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #e9e9e9;
}
.theme--dark .toolbar {
  background: #454547;
  border-radius: 10px;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.theme--dark .toolbar-chart .toolbar-chart-title-row {
  padding-top: 28px;
}
.theme--dark .toolbar-chart .markets-select {
  padding-top: 20px;
}
.theme--dark .toolbar-chart {
  background: #454547;
  border-radius: 10px;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.theme--dark .main-card {
  background: #212121;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  border-radius: 15px;
  padding: 32px;
}
@media (max-width: 1264px) {
  .sell-order {
    padding-right: 4px !important;
  }
  .overall-statistics {
    padding-left: 4px !important;
    padding-top: 32px !important;
  }
}
@media (max-width: 600px) {
  .toolbar-chart {
    height: 144px;
  }
  .toolbar-layout {
    flex-direction: column-reverse;
    padding-top: 68px;
    margin-left: 8px;
  }
  .toolbar-chart-title-row .toolbar-title {
    text-align: left;
  }
  >>> .main-card {
    padding: 32px 16px !important;
  }
}
@media (max-width: 380px) {
  .statistic-row-one {
    margin-top: 8px !important;
  }
  .statistic-row-two {
    margin-top: 10px;
  }
}
@media (max-width: 378px) {
  .statistic-row-two {
    margin-top: 20px;
  }
}
</style>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import TradeDetails from "~/components/openorders/TradeDetails";
import StockChart from "~/components/openorders/StockChart";
import _ from "lodash";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import AddManualBuyOrderAccumulatedFunds from "../components/openorders/AddManualBuyOrderAccumulatedFunds";
import swal from "sweetalert2";
import MarketActions from "~/components/openorders/MarketActions";

export default {
  components: {
    TradeDetails,
    StockChart,
    AddManualBuyOrderAccumulatedFunds,
    MarketActions
  },

  props: {
    uuid: {
      type: String,
      default: ""
    }
  },

  data: () => ({
    stats: {
      totalOpenSellOrders: 0,
      totalOpenBuyOrders: 0
    },
    selectedMarket: "",
    activeMarkets: [],
    openOrders: [],
    openBuyOrders: [],
    closedBuyOrders: [],
    closedSellOrders: [],
    openOrderCount: 0,
    addManualBuyOrderDialogOpened: false,
    windowWidth: window.innerWidth
  }),
  computed: {
    ...mapGetters({
      markets: "markets/markets",
      themeDark: "settings/darkmode"
    }),
    openOrderHeaders: function() {
      if (this.isMobile) {
        return [
          {
            text: `Opened (${moment()
              .tz(moment.tz.guess())
              .format("z")})`,
            value: "ts_opened_utc"
          },
          { text: "Price", value: "price" }
        ];
      } else {
        return [
          {
            text: `Opened (${moment()
              .tz(moment.tz.guess())
              .format("z")})`,
            value: "ts_opened_utc"
          },
          { text: "Price", value: "price" },
          { text: "Quantity", value: "quantity" },
          { text: "Order ID", value: "uuid" }
        ];
      }
    },
    isMobile() {
      return this.windowWidth < 600;
    },
    buyOrderLevels: function() {
      let levels = [];
      this.openBuyOrders.map(order => {
        levels.push(order.price);
      });
      return levels;
    },
    sellOrderLevels: function() {
      let levels = [];
      this.openOrders.map(order => {
        levels.push(order.price);
      });
      return levels;
    },
    closedBuyOrderLevels: function() {
      let levels = [];

      _.sortBy(this.closedBuyOrders, ["timestamp"]);

      this.closedBuyOrders.map(order => {
        levels.push({
          price: order.price,
          quantity: order.quantity,
          timestamp: order.timestamp
        });
      });
      return levels;
    },
    closedSellOrderLevels: function() {
      let levels = [];
      this.closedSellOrders.map(order => {
        levels.push({
          price: order.price,
          quantity: order.quantity,
          timestamp: order.timestamp
        });
      });
      return levels;
    }
  },

  created: async function() {
    axios.get("/api/v1/openorders/activemarkets").then(res => {
      let activeMarkets = [];
      res.data.map(value => {
        activeMarkets.push({
          text: value.text,
          value: value.value
        });
      });
      this.activeMarkets = activeMarkets;
    });

    axios.get("/api/v1/openorders/stats").then(res => {
      this.stats = res.data;
    });

    if (!this.$store.getters["markets/markets"]) {
      await this.$store.dispatch("markets/fetchMarkets");
    }
    if (!this.$store.getters["markets/marketsAll"]) {
      await this.$store.dispatch("markets/fetchMarketsAll");
    }
  },

  methods: {
    getSellOrders: function(selectedMarket) {
      return axios.get("/api/v1/openorders/sellorders/" + selectedMarket);
    },
    getBuyOrders: function(selectedMarket) {
      return axios.get("/api/v1/openorders/buyorders/" + selectedMarket);
    },
    getClosedSellOrders: function(selectedMarket) {
      return axios.get("/api/v1/openorders/closedsellorders/" + selectedMarket);
    },
    getClosedBuyOrders: function(selectedMarket) {
      return axios.get("/api/v1/openorders/closedbuyorders/" + selectedMarket);
    },
    loadOpenOrders: async function(selectedMarket) {
      let that = this;
      await axios
        .all([
          this.getSellOrders(selectedMarket),
          this.getBuyOrders(selectedMarket),
          this.getClosedSellOrders(selectedMarket),
          this.getClosedBuyOrders(selectedMarket)
        ])
        .then(
          axios.spread(function(
            sellOrders,
            buyOrders,
            closedSellOrders,
            closedBuyOrders
          ) {
            that.openOrders = sellOrders.data;
            that.openBuyOrders = buyOrders.data;
            that.closedSellOrders = closedSellOrders.data;
            that.closedBuyOrders = closedBuyOrders.data;
            that.selectedMarket = selectedMarket;
          })
        );
    },
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    },
    closeDialogForManualBuy() {
      this.addManualBuyOrderDialogOpened = false;
    },
    onClickInfoPopUp: async function(value) {
      this.infoAlert(
        this.$t("market_actions.release_funds_title"),
        this.$t("market_actions.release_funds_text")
      );
    },
    clickInfoPopUp: function(value) {
      this.addManualBuyOrderDialogOpened = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/pages/openorders.vue